import { css } from 'react-emotion';
import { colors, fontSize, lineHeight, mq } from '../../../../../css';

const s = {};
s.slideWrapper = css`
    display: flex;
    flex-direction: column;
    .carousel__inner-slide {
        display: flex;
        flex-direction: column;
    }
`;

s.imageWrapper = css`
    ${mq({
        paddingTop: [0, 0, 0, 40, 60],
    })};
    flex-grow: 1;

    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        max-width: 440px;
        ${mq({
            width: ['90%', '90%', '60%', '80%'],
        })};
        width: 90%;
        height: 100%;
    }
`;

s.textWrapper = css`
    ${mq({
        height: [200, 190, 200, 190, 200],
    })};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    p {
        ${mq({
            width: ['100%', '100%', 300],
        })};
        margin: 0 0 20px;
        color: ${colors.blue};
        font-size: ${fontSize(12)};
        line-height: ${lineHeight(24, 16)};
    }
    em {
        font-style: normal;
        font-weight: 600;
    }
`;

export default s;



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slideStyles.js